import { defineComponent } from 'vue';
export default defineComponent({
    name: 'LedDebug',
    props: {
        id: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        updateLed(name, value) {
            this.$emit('updateLed', { name, value });
        }
    }
});
